import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Image, View, Text, TouchableOpacity } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then } from "react-if";
import { FormattedMessage } from "react-intl";
import styles from "./style";

const CardsHome = () => {
  const navigation = useNavigation();
  const [country, setCountry] = useState("");

  const getCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setCountry(country);
  };

  useEffect(() => {
    getCountry();
  }, []);

  const handlePressPurchase = () => {
    if (country === "italia") {
      // Definir o ativo específico de crédito de carbono para "italia"
      navigation.navigate("Purchase", {
        viewType: "buy",
        selectedActive: 5, // ID do ativo de crédito de carbono
      });
    } else {
      navigation.navigate("Purchase", {
        viewType: "buy",
      });
    }
  };

  return (
    <View
      style={{ flex: 1, marginTop: 25, flexDirection: "row", flexWrap: "wrap" }}
    >
      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("DepositMethod")}
          style={[
            styles.card,
            country === "italia" ? styles.cardDestacado : null,
          ]}
        >
          <Image
            source={require("../../../assets/home/icons/depositar.svg")}
            style={[
              styles.img,
              country === "italia" ? styles.iconDestacado : null,
            ]}
          />
          <Text
            style={[
              styles.textCard,
              country === "italia" ? styles.textDestacado : null,
            ]}
          >
            <FormattedMessage id="cardsHome.depositar" />
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={handlePressPurchase}
          style={[
            styles.card,
            country === "italia" ? styles.cardDestacado : null,
          ]}
        >
          <Image
            source={require("../../../assets/home/icons/comprar.svg")}
            style={[
              styles.img,
              country === "italia" ? styles.iconDestacado : null,
            ]}
          />
          <Text
            style={[
              styles.textCard,
              country === "italia" ? styles.textDestacado : null,
            ]}
          >
            <FormattedMessage id="cardsHome.comprar" />
          </Text>
        </TouchableOpacity>
      </View>

      <If condition={country === "brasil"}>
        <Then>
          <View style={styles.contentCard}>
            <TouchableOpacity
              onPress={() =>
                navigation.navigate("Purchase", { viewType: "sell" })
              }
              style={styles.card}
            >
              <Image
                source={require("../../../assets/home/icons/vender.svg")}
                style={styles.img}
              />
              <Text style={styles.textCard}>
                <FormattedMessage id="cardsHome.vender" />
              </Text>
            </TouchableOpacity>
          </View>
        </Then>
      </If>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("WithdrawMethod")}
          style={styles.card}
        >
          <Image
            source={require("../../../assets/home/icons/sacar.svg")}
            style={styles.img}
          />
          <Text style={styles.textCard}>
            <FormattedMessage id="cardsHome.sacar" />
          </Text>
        </TouchableOpacity>
      </View>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("Transfer")}
          style={styles.card}
        >
          <Image
            source={require("../../../assets/home/icons/transferir.svg")}
            style={styles.img}
          />
          <Text style={styles.textCard}>
            <FormattedMessage id="cardsHome.transferir" />
          </Text>
        </TouchableOpacity>
      </View>

      <If condition={country === "brasil"}>
        <Then>
          <View style={styles.contentCard}>
            <TouchableOpacity
              onPress={() => navigation.navigate("Exchange")}
              style={styles.card}
            >
              <Image
                source={require("../../../assets/home/icons/ordens.svg")}
                style={styles.img}
              />
              <Text style={styles.textCard}>
                <FormattedMessage id="cardsHome.ordens" />
              </Text>
            </TouchableOpacity>
          </View>
        </Then>
      </If>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("Wallet")}
          style={styles.card}
        >
          <Image
            source={require("../../../assets/home/icons/emitirCertificado.svg")}
            style={styles.img}
          />
          <Text style={[styles.textCard, { fontSize: 8, textAlign: "center" }]}>
            <FormattedMessage id="cardsHome.emitirCertificados" />
          </Text>
        </TouchableOpacity>
      </View>

      <If condition={country === "italia"}>
        <Then>
          <View style={styles.contentCard}>
            <TouchableOpacity
              onPress={() => navigation.navigate("Wallet", { tabIndex: 2 })}
              style={styles.card}
            >
              <Image
                source={require("../../../assets/home/icons/emitirCertificado.svg")}
                style={styles.img}
              />
              <Text
                style={[
                  styles.textCard,
                  { fontSize: 8, textAlign: "center", lineHeight: 8 },
                ]}
              >
                <FormattedMessage id="cardsHome.certificadosEmitidos" />
              </Text>
            </TouchableOpacity>
          </View>
        </Then>
      </If>

      <View style={styles.contentCard}>
        <TouchableOpacity
          onPress={() => navigation.navigate("Traceability")}
          style={styles.card}
        >
          <Image
            source={require("../../../assets/home/icons/security.svg")}
            style={styles.img}
          />
          <Text
            style={[
              styles.textCard,
              { fontSize: 9, textAlign: "center", lineHeight: 9 },
            ]}
          >
            <FormattedMessage id="cardsHome.btnRastreabilidade" />
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default CardsHome;
